<!--PILOT BOARDING PLACE - INKOMENDE REIZEN-->
@if (context.visit.orderIncomingMovement) {
  <div class="d-flex flex-column">
    <div class="fieldset">
      <app-form-group>
        <label>Pilot boarding place</label>
        @if (!context.accessPointsAsPilotBoardingPlaces()) {
          <app-select [(ngModel)]="context.visit.visitDeclaration.portVisit.pilotStation"
            (ngModelChange)="setEtaIfPilotBoardingPlaceIsMaascenter($event)" [optionsProvider]="pilotStations"
            dataKey="name" [formatter]="pilotBoardingPlaceFormatter"
            placeholder="– Select a pilot boarding place –"
            required [disabled]="context.isArrived()" id="pilotBoardingPlace">
            <div class="invalid-feedback">Please select a pilot boarding place</div>
          </app-select>
        }
        @if (context.accessPointsAsPilotBoardingPlaces()) {
          <input disabled class="form-control"
            [ngModel]="context.visit.visitDeclaration.portVisit.pilotStation?.name" />
        }
      </app-form-group>
    </div>
    @if (!context.accessPointsAsPilotBoardingPlaces() || context.visit.visitDeclaration.portVisit.pilotStation) {
      <div>
        <app-form-group label="ETA pilot boarding place">
          <app-tidal-window [status]="context.visit.incomingTidalWindowStatus"
            [level]="context.visit.visitDeclaration.portVisit.firstMovement.order ? 'error' : 'warning'">
            <app-date-field [(ngModel)]="context.visit.visitDeclaration.portVisit.portEntry.etaPilotBoardingPlace"
              [required]="etaPilotBoardingPlaceRequired" (ngModelChange)="onEtaPbpChanged($event)"
            [calendarStartDate]="context.visit.visitDeclaration.portVisit.etdPort" [disabled]="etaPilotBoardingPlaceDisabled" id="etaPBP"></app-date-field>
          </app-tidal-window>
        </app-form-group>
      </div>
      <div>
        <app-planning-history
          [movementSpecifiers]="['Incoming', 'arrival']"
          [planningHistory]="context.visit.incomingMovementHarbourMasterInfo.planningHistory"
          [declaredDate]="context.savedVisit.visitDeclaration.portVisit.portEntry?.etaPilotBoardingPlace"
          [originallyDeclaredDate]="context.visit.incomingMovementHarbourMasterInfo.basedOnTime">
        </app-planning-history>
      </div>
      @if (validator.etaPBPIsBeforeEtdOfOtherVessel()) {
        <span class="ng-invalid invalid-feedback mb-2">Eta should be the same or after ETD of other vessel</span>
      }
      @if (validator.etaPBPIsSameOrAfterFirstBerth() ) {
        <span class="ng-invalid invalid-feedback mb-2">First berth visit should be after eta pilot boarding place</span>
      }
      @if (validator.etaPortIsSameOrBeforePreviousPort()) {
        <span class="ng-invalid invalid-feedback mb-2">Last previous port should be before eta pilot boarding place</span>
      }
      @if (validator.etaPortIsSameOrAfterEtdPort()) {
        <span class="ng-invalid invalid-feedback mb-2">Eta port should be before etd port</span>
      }
    }
  </div>
}

